import toKebabCase from './toKebabCase'

export default (attributes) => (el) =>
  attributes.reduce(
    (acc, key) => ({ ...acc, [key]: el.getAttribute(toKebabCase(key)) }),
    {},
  )
